import React, { memo } from "react";

const Input = ({
  className,
  name,
  id,
  type,
  value,
  onChange,
  autoFocus = false,
  disabled = false,
  placeholder = "",
  ...props
}) => {
  return (
    <>
      <input
        className={className}
        name={name}
        id={id}
        type={type}
        value={value}
        onChange={onChange}
        autoFocus={autoFocus}
        disabled={disabled}
        placeholder={placeholder}
        {...props}
      />
    </>
  );
};

export default memo(Input);
